module.exports = __webpack_public_path__ + "static/media/facebook-f-brands4d25adff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/facebook-f-brands.svg
// module id = 1527
// module chunks = 0